import logo from "./assets/logo.png";
// import './App.css';
import Mainroutes from "./Routes/MainRoutes";
function App() {
  return (
    <>
      {" "}
      <Mainroutes />
    </>
  );
}

export default App;
